import { Content, Row, Col, Button, H1, H2, H3 } from 'components/common'
import { React, Image, styled, mq } from 'x'
import { Link } from 'gatsby'
import Arrow from 'static/svg/arrow.svg'

const Container = styled.div`
box-sizing: border-box;
  display: block;
  padding: 60px 30px;
  margin-left:auto;
  margin-right:auto;
  margin-top:0;
  margin-bottom:0;
`

const SectionContent = styled(Content)`
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
  padding:0 30px;
  
  ${mq.below('lg')} {
    padding: 0 30px;
  }
  ${mq.below('md')} {
    padding: 0 30px;
  }
  ${mq.below('sm')} {
    padding: 0 15px;
  }
`

const Title = styled(H1)`
  max-width: 100%;
  color: #000;
  text-align:center;
  width: 100%;
  margin-top:0;
  margin-bottom: 0;
  font-size:42px;
  line-height: 1.2;
  font-weight:800;
`

const Subtitle = styled(H2)`
  max-width: 100%;
  color: #000;
  text-align:center;
  width: 100%;
  margin-top:0;
  margin-bottom: 30px;
  font-size:36px;
  line-height:1.2;
  font-weight:600;
`

const Text = styled.div`
  color:#FFF;
  p {
    margin-top:0;
  }
`

const Section = props => {

  return (
    <Container style={{backgroundColor: props.data.bgColour || 'black' }}>
      <SectionContent>
        <Row>
          <Col>
            {props.data.title && (<Title style={{color: props.data.textColour || 'white' }}>{props.data.title}</Title>)}
            {props.data.subtitle && (<Subtitle style={{color: props.data.textColour || 'white' }}>{props.data.subtitle}</Subtitle>)}
            {props.data.text && (<Text style={{color: props.data.textColour || 'white' }} dangerouslySetInnerHTML={{ __html: props.data.text }} />)}
          </Col>
        </Row>
      </SectionContent>
    </Container>
  )
}

export default Section
